import { NvTableCellProps } from 'shared/components/nv-table';
import { OrganizationUsersSearchUserResult } from 'redux/schemas/api/user';

export enum ColumnID {
  NAME = 'name',
  ADD = 'add',
}

export type ParticipantRowProps = OrganizationUsersSearchUserResult & {
  onAdd?: () => void;
};

export type CellProps = NvTableCellProps<ParticipantRowProps>;
